module.exports = __webpack_public_path__ + "static/index/img/baikal-111.aeb6a8f8.jpg";